import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Observer from 'react-intersection-observer';
import CmsWidget from 'components/CmsWidget';
import cn from './styles.local.less';

export default class SellWidget extends PureComponent {
  static propTypes = {
    html: PropTypes.string,
    js: PropTypes.string,
  };

  state = {
    isWidgetIntersected: false,
  };

  handleSellWidgetObserver = (isWidgetIntersected) => {
    if (isWidgetIntersected) {
      this.setState({ isWidgetIntersected: true });
    }
  };

  render() {
    const { html, js } = this.props;
    const { isWidgetIntersected } = this.state;

    return html ? (
      <div className={cn.root}>
        <Observer
          threshold={0}
          rootMargin="0px 0px 300px 0px"
          onChange={this.handleSellWidgetObserver}
        >
          {isWidgetIntersected ? <CmsWidget html={html} js={js} /> : null}
        </Observer>
      </div>
    ) : null;
  }
}
